// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="'Edit loan information'"></sub-header>

    <form name="\$ctrl.form">
      <customer-loan-create-lai-details
        form-lai="formLai"
        loan-information="\$ctrl.clonedLoan.loanInformation"
        loan-collaterals="\$ctrl.clonedLoan.collaterals"
        loan-product="\$ctrl.clonedLoan.loanType"
        validate-files="\$ctrl.validateFiles"
        loan-status="\$ctrl.clonedLoan.status"
        set-default-values="false"
        category-ids="\$ctrl.clonedLoan.categoryIds"
        custom-field-values="\$ctrl.customFieldValues"
        branch-id="\$ctrl.clonedLoan.branchId"
        customer-id="\$ctrl.customerId"
      >
      </customer-loan-create-lai-details>

      <h2 class="section-header section-header--upper-margin">Cocree information</h2>
      <negative-information form-ni="formNi"
                            loan-status="\$ctrl.clonedLoan.status"
                            negative-information="\$ctrl.clonedLoan.negativeInformation"
                            edit-mode="true">
      </negative-information>

      <h2 class="section-header section-header--upper-margin">Loan parameters</h2>
      <table class="table">
        <tbody>
        <tr ng-if="\$ctrl.showReleaseDate">
          <td class="label">Release date</td>
          <td>
            <date output-format="local-date"
                  ng-if="!\$ctrl.loan.releaseDate"
                  min="\$ctrl.clonedLoan.grantDate"
                  init-with-null="true"
                  max="\$ctrl.clonedLoan.firstAmortizationDueDate"
                  ng-model="\$ctrl.clonedLoan.releaseAllowedDate"></date>
            <date output-format="local-date"
                  init-with-null="true"
                  ng-if="\$ctrl.loan.releaseDate"
                  ng-model="\$ctrl.loan.releaseDate"
                  ng-disabled="true"></date>
          </td>
        </tr>
        <tr>
          <td class="label">Loan officer:</td>
          <td class="values">
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.clonedLoan.officerId"
              users="\$ctrl.loanOfficers">
            </user-select>
          </td>
        </tr>
        <tr>
          <td class="label">Loan collector:</td>
          <td class="values">
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.clonedLoan.collectorId"
              users="\$ctrl.collectors">
            </user-select>
          </td>
        </tr>
        <tr>
          <td class="label">CBU account:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.cbuSavingsAccountId"
                    ng-options="entry.id as entry.label for entry in \$ctrl.cbuAccounts">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">PF account:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.pfSavingsAccountId"
                    ng-options="entry.id as entry.label for entry in \$ctrl.pfAccounts">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">TP account:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.tpSavingsAccountId"
                    ng-options="entry.id as entry.label for entry in \$ctrl.tpAccounts">
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loan.loanType.withLinkedDepositAccount || \$ctrl.loan.linkedDepositAccountId">
          <td class="label">Allow linked deposit:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.allowLinkedDeposit"
                    ng-change="\$ctrl.allowLinkedDepositChanged()"
                    boolean-options
                    required>
            </select>
          </td>
        </tr>
        <tr ng-if="(\$ctrl.loan.loanType.withLinkedDepositAccount || \$ctrl.loan.linkedDepositAccountId) && \$ctrl.clonedLoan.allowLinkedDeposit">
          <td class="label">Linked deposit account:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.linkedDepositAccountId"
                    ng-required="\$ctrl.clonedLoan.allowLinkedDeposit"
                    ng-options="entry.id as entry.label for entry in \$ctrl.linkedDepositAccounts">
            </select>
          </td>
        </tr>
        </tbody>
      </table>

      <h2 class="section-header section-header--upper-margin">Loan configuration</h2>
      <table class="table">
        <tbody>
        <tr ng-if="\$ctrl.clonedLoan.allowAccrual || \$ctrl.clonedLoan.loanType.allowAccrual">
          <td class="label">Auto accrual:</td>
          <td class="values">
            <select ng-model="\$ctrl.clonedLoan.allowAccrual"
                    boolean-options
                    required>
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Extra number:</td>
          <td class="values">
            <input type="text"
                   ng-model="\$ctrl.clonedLoan.extraNumber">
          </td>
        </tr>
        <tr>
          <td class="label">Due and demandable threshold:</td>
          <td class="values">
            <input type="number"
                   ng-model="\$ctrl.clonedLoan.dueAndDemandableThreshold"
                   required>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  <div class="buttons">
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
    <button class="btn btn-primary" ng-click="\$ctrl.save()"
            ng-disabled="\$ctrl.form.\$invalid">
      Save
    </button>
  </div>

</section>


`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-information.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;